import { Chip } from "@heroui/react";
import { useTranslation } from "react-i18next";

function DoNotIrrigateChip() {
    const { t } = useTranslation();
    return (
        <Chip
            classNames={{
                base: "bg-green-100 font-bold",
                content: "font-bold text-green-700",
            }}
            radius="sm"
            size="sm"
        >
            {t("do_not_irrigate", {
                ns: "fields-list",
            })}
        </Chip>
    );
}

export default DoNotIrrigateChip;
